import {del, get, post, put} from "../helpers/api_helper";
import {
    IPermission,
    IPermissionForm,
    IPermissionGroupById,
    IPermissionGroupForm,
    IPermissionGroupPagination
} from "../store/permissions/types";

export const PermissionsService = {
    // GROUPS
    getGroupsAll: async (): Promise<IPermissionGroupPagination> => {
        return get(`/permission-groups`)
    },

    getGroupById: async (id: number): Promise<IPermissionGroupById> => {
        return get(`/permission-groups/${id}`)
    },

    createGroup: async (data: IPermissionGroupForm) => {
        return post(`/permission-groups`, data)
    },

    updateGroup: async (id: number, data: IPermissionGroupForm) => {
        return put(`/permission-groups/${id}`, data)
    },

    removeGroup: async (id: number) => {
        return del(`/permission-groups/${id}`)
    },

    // PERMISSIONS
    getPermissionsAll: async (): Promise<IPermission[]> => {
        return get(`/permissions`)
    },

    getPermissionById: async (id: number): Promise<IPermission> => {
        return get(`/permissions/${id}`)
    },

    createPermission: async (data: IPermissionForm) => {
        return post(`/permissions`, {...data, group_id: data.groupId})
    },

    updatePermission: async (id: number, data: IPermissionForm) => {
        return put(`/permissions/${id}`, {...data, group_id: data.groupId})
    },

    removePermission: async (id: number) => {
        return del(`/permissions/${id}`)
    },
}